'use strict';/* global define:false */define('modules/admin/states/admin/index',['require','./controller','text!./template.html','./resolve/appConfig'],function(require){'use strict';/**
   * Define the data restriction based on the roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object}   ROLES     - Definition of the possible roles.
   *
   * @return {Object}            - Resolves promise for roleCheck.
   */// @ngInject
restricted.$inject = ["roleCheck", "ROLES"];
menu.$inject = ["roleCheck", "ROLES"];
function restricted(roleCheck,ROLES){return roleCheck.promise(ROLES.admin,ROLES.hrAdmin,ROLES.hrAdminExtended);}/**
   * Verify the provided roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object}   ROLES     - Definition of the possible roles.
   *
   * @return {Boolean}           - Boolean indicating whether user has specified
   *                               roles or not.
   */// @ngInject
function menu(roleCheck,ROLES){return roleCheck(ROLES.admin,ROLES.hrAdmin,ROLES.hrAdminExtended);}return{url:'/admin',views:{'body@app':{controller:require('./controller'),controllerAs:'AdminCtrl',template:require('text!./template.html')}},resolve:{appConfig:require('./resolve/appConfig')},data:{restricted:restricted},meta:{label:'ADMIN.LABEL',icon:'&#xE407;',menu:menu}};});
